export default __webpack_public_path__ + "fd47d1bebbb3ae9c6abf9b419bc69391.png";